import { render, staticRenderFns } from "./invoicePage.vue?vue&type=template&id=8a870012&scoped=true&"
import script from "./invoicePage.vue?vue&type=script&lang=js&"
export * from "./invoicePage.vue?vue&type=script&lang=js&"
import style0 from "./invoicePage.vue?vue&type=style&index=0&id=8a870012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a870012",
  null
  
)

export default component.exports